import React from "react";
import { Check } from "lucide-react";
import Call from "@/model/interface/Call";
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { useGetCallDispositionsQuery, useUpdateCallMutation } from "@/store/rest_api";

interface CallDispositionMenuItemsProps {
  call: Call;
}

const CallDispositionMenuItems: React.FC<CallDispositionMenuItemsProps> = ({ call }) => {
  const { data: dispositions = [] } = useGetCallDispositionsQuery({});
  const [updateCall] = useUpdateCallMutation();

  return (
    <>
      {dispositions.map((disposition) => (
        <DropdownMenuItem
          key={disposition.id}
          onClick={(event) => {
            event.stopPropagation();
            if (call.id && disposition.id) {
              void updateCall({ id: call.id, disposition: { id: disposition.id } });
            }
          }}
        >
          <span className="mr-2 h-2 w-2 rounded-full" style={{ backgroundColor: disposition.color }} />
          {disposition.name}
          {call.disposition?.id === disposition.id && <Check className="ml-auto h-4 w-4" />}
        </DropdownMenuItem>
      ))}
    </>
  );
};

export default CallDispositionMenuItems;
